import {
  GET_VOUCHER_LIST,
  GET_VOUCHER_LIST_SUCCESS,
  GET_VOUCHER_LIST_FAILED,

  GET_VOUCHER_DETAIL,
  GET_VOUCHER_DETAIL_SUCCESS,
  GET_VOUCHER_DETAIL_FAILED,

  CREATE_VOUCHER_CAMPAIGN,
  CREATE_VOUCHER_CAMPAIGN_SUCCESS,
  CREATE_VOUCHER_CAMPAIGN_FAILED,

  UPDATE_VOUCHER_CAMPAIGN,
  UPDATE_VOUCHER_CAMPAIGN_SUCCESS,
  UPDATE_VOUCHER_CAMPAIGN_FAILED,

  ADD_CODE_TO_VOUCHER_CAMPAIGN,
  ADD_CODE_TO_VOUCHER_CAMPAIGN_SUCCESS,
  ADD_CODE_TO_VOUCHER_CAMPAIGN_FAILED,

  DELETE_VOUCHERS_FROM_CAMPAIGN,
  DELETE_VOUCHERS_FROM_CAMPAIGN_SUCCESS,
  DELETE_VOUCHERS_FROM_CAMPAIGN_FAILED,

  DELETE_VOUCHER_CAMPAIGN,
  DELETE_VOUCHER_CAMPAIGN_SUCCESS,
  DELETE_VOUCHER_CAMPAIGN_FAILED,

  CLEAR_VOUCHER_DETAIL,
} from './actionTypes';

const initialState = {
  isLoadingGetVoucherList: false,
  isLoadingGetVoucherDetail: false,
  isLoadingCreateVoucherCampaign: false,
  isLoadingUpdateVoucherCampaign: false,
  isLoadingAddCode: false,
  isLoadingDeleteVouchers: false,
  isLoadingDeleteVoucherCampaign: false,

  voucherList: [],
  voucherTotal: 0,
  voucherDetail: {},
};

export default function voucher(state = initialState, action) {
  switch (action.type) {
    // LIST
    case GET_VOUCHER_LIST:
      return {
        ...state,
        isLoadingGetVoucherList: true,
      };

    case GET_VOUCHER_LIST_SUCCESS: {
      const data = action.payload?.data || action.payload || [];
      const total = action.payload?.total || data.length;
      return {
        ...state,
        isLoadingGetVoucherList: false,
        voucherList: data,
        voucherTotal: total,
      };
    }

    case GET_VOUCHER_LIST_FAILED:
      return {
        ...state,
        isLoadingGetVoucherList: false,
      };

    // DETAIL
    case GET_VOUCHER_DETAIL:
      return {
        ...state,
        isLoadingGetVoucherDetail: true,
      };

    case GET_VOUCHER_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingGetVoucherDetail: false,
        voucherDetail: action.payload,
      };

    case GET_VOUCHER_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetVoucherDetail: false,
      };

    // CREATE
    case CREATE_VOUCHER_CAMPAIGN:
      return {
        ...state,
        isLoadingCreateVoucherCampaign: true,
      };

    case CREATE_VOUCHER_CAMPAIGN_SUCCESS:
      return {
        ...state,
        isLoadingCreateVoucherCampaign: false,
      };

    case CREATE_VOUCHER_CAMPAIGN_FAILED:
      return {
        ...state,
        isLoadingCreateVoucherCampaign: false,
      };

    // UPDATE
    case UPDATE_VOUCHER_CAMPAIGN:
      return {
        ...state,
        isLoadingUpdateVoucherCampaign: true,
      };

    case UPDATE_VOUCHER_CAMPAIGN_SUCCESS:
      return {
        ...state,
        isLoadingUpdateVoucherCampaign: false,
      };

    case UPDATE_VOUCHER_CAMPAIGN_FAILED:
      return {
        ...state,
        isLoadingUpdateVoucherCampaign: false,
      };

    // ADD CODE
    case ADD_CODE_TO_VOUCHER_CAMPAIGN:
      return {
        ...state,
        isLoadingAddCode: true,
      };

    case ADD_CODE_TO_VOUCHER_CAMPAIGN_SUCCESS:
      return {
        ...state,
        isLoadingAddCode: false,
      };

    case ADD_CODE_TO_VOUCHER_CAMPAIGN_FAILED:
      return {
        ...state,
        isLoadingAddCode: false,
      };

    // DELETE VOUCHERS
    case DELETE_VOUCHERS_FROM_CAMPAIGN:
      return {
        ...state,
        isLoadingDeleteVouchers: true,
      };

    case DELETE_VOUCHERS_FROM_CAMPAIGN_SUCCESS:
      return {
        ...state,
        isLoadingDeleteVouchers: false,
      };

    case DELETE_VOUCHERS_FROM_CAMPAIGN_FAILED:
      return {
        ...state,
        isLoadingDeleteVouchers: false,
      };

    // DELETE CAMPAIGN
    case DELETE_VOUCHER_CAMPAIGN:
      return {
        ...state,
        isLoadingDeleteVoucherCampaign: true,
      };

    case DELETE_VOUCHER_CAMPAIGN_SUCCESS:
      return {
        ...state,
        isLoadingDeleteVoucherCampaign: false,
      };

    case DELETE_VOUCHER_CAMPAIGN_FAILED:
      return {
        ...state,
        isLoadingDeleteVoucherCampaign: false,
      };

    // CLEAR
    case CLEAR_VOUCHER_DETAIL:
      return {
        ...state,
        voucherDetail: {},
      };

    default:
      return state;
  }
}
